import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import Textarea from 'components/inputs/textarea';
import { setNotes } from 'features/structure';
import useMediaQuery from 'hooks/use-media-query';
import { useState } from 'react';

export default function ProjectNotes() {
  const dispatch = useAppDispatch();
  const { notes } = useAppSelector((state) => state.structure);
  const { showChatPanel, activeTab } = useAppSelector((state) => state.ui);
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const isLargeScreen = useMediaQuery('(min-width: 1280px)');
  const isProjectDetailsPage = activeTab === 'project';
  const expanded =
    isHovered || isFocused || (isProjectDetailsPage && isLargeScreen);

  return (
    <label
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={clsx(
        'absolute top-4 z-30 flex cursor-text flex-col overflow-hidden rounded-md bg-yellow-200 shadow-lg ring-1 ring-yellow-300 transition-all duration-200',
        showChatPanel ? 'right-[416px]' : 'right-4',
        expanded ? 'h-64 w-80 rotate-0 p-3' : 'h-14 w-14 rotate-3 p-2'
      )}
    >
      <span
        className={clsx(
          'mb-1 shrink-0 text-sm font-bold text-yellow-900',
          !expanded && 'hidden'
        )}
      >
        Project Notes
      </span>
      <Textarea
        value={notes}
        onChange={(value) => dispatch(setNotes(value))}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        debounce={500}
        aria-label='Project notes'
        className={clsx(
          'grow border-none bg-transparent p-0 text-sm text-yellow-900 shadow-none placeholder:text-yellow-700/60 focus:ring-0',
          !expanded && 'hidden'
        )}
      />
      <div
        className={clsx(
          'flex h-full w-full flex-col items-center justify-center gap-0.5 text-yellow-900',
          expanded && 'hidden'
        )}
      >
        <DocumentTextIcon className='h-5 w-5' />
        <span className='text-[10px] font-semibold'>Notes</span>
      </div>
    </label>
  );
}
